'use strict';
app.controller('internalRegistrationController', ['$scope', 'LoginService', '$location', '$cookies', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', '$http', '$routeParams', 'CommonService', function ($scope, loginService, $location, $cookies, AuthenticationService, progressBarService, $rootScope, $timeout, $http, $routeParams, commonService) {
    if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') != 'SAdmin') {
        $location.path('/login');
        return
    }

    $scope.isError = false;
    $scope.isSuccess = false;
    $scope.origPath = getLocalValue('origPath');
    var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

    var Clear = function () {
        $scope.profileDataModel();
        $('.border-red').removeClass('border-red');

        $scope.profileForm.$setPristine();
        $scope.profileForm.$setUntouched();
    }

    $scope.profileDataModel = function () {
        $scope.profileData = {
            firstName: "",
            lastName: "",
            emailId: "",
            InstitutionId: "",
            InstitutionName: "",
            admin: false,
            startDate: '',
            subscription: 'month',
            isKratosData: false
        }
    }

    $scope.reloadDatePicker = function () {
        $('.daterangepickerInp').daterangepicker({
            singleDatePicker: true,
            showDropdowns: true,
            minDate: new Date(),
            locale: {
                format: 'MM-DD-YYYY'
            }
        });
    }
    $scope.reloadDatePicker();

    $scope.profileDataModel();

    //$scope.disableSearchInstitute = function (e) {
    //    if ($(e.currentTarget).prop('checked')) {
    //        $('#affiliationName').attr('disabled', 'disabled');
    //    } else {
    //        $('#affiliationName').removeAttr('disabled');
    //    }
    //    $('#affiliationName').val('');
    //    $scope.searchAffiliation = "";
    //    $scope.selectedInstitute.InstitutionName = "";
    //    $scope.selectedInstitute.userDefinedAffiliation = "";
    //}

    $scope.selectAffiliation = function () {
        $('#affiliationName').val('');
        $scope.selectedInstitute.userDefinedAffiliation = "";
        $scope.selectedInstitute.InstitutionId = $scope.profileData.InstitutionId;
        if (!$scope.selectedInstitute.isAffiliationExists) {
            $scope.selectedInstitute.InstitutionName = $scope.profileData.InstitutionName;
        } else {
            if ($scope.profileData.InstitutionName.length == 0) {
                $scope.selectedInstitute.isAffiliationExists = false
                //$('#affiliationName').removeAttr('disabled');
            }
            $scope.selectedInstitute.userDefinedAffiliation = $scope.profileData.InstitutionName;
        }

        $('#affiliation').modal('show');
    }

    //var institutions = new Bloodhound({
    //    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
    //    queryTokenizer: Bloodhound.tokenizers.whitespace,
    //    remote: {
    //        url: serviceBase + 'api/Account/institutions?query=%QUERY',
    //        prepare: function (query, settings) {
    //            settings.beforeSend = (function () {
    //                $('.autopopulate-spinner').show();
    //                $scope.selectedInstitute.userDefinedAffiliation = query;
    //                if ($scope.profileData.admin && $scope.profileData.InstitutionName == '') {
    //                    $scope.profileForm.instituteName.$dirty = true;
    //                    $scope.profileForm.instituteName.$invalid = true;
    //                }
    //                else {
    //                    $scope.profileForm.instituteName.$dirty = true;
    //                    $scope.profileForm.instituteName.$valid = true;
    //                }
    //                $scope.$apply();
    //            })();
    //            return $.extend(settings, {
    //                url: settings.url.replace('%QUERY', encodeURIComponent(query)),
    //                error: function (jqxhr, textStatus, errorThrown) {

    //                    $('.autopopulate-spinner').hide();
    //                },
    //                success: function (data, textStatus, jqxhr) {
    //                }
    //            });
    //        },
    //        clearRemoteCache: function clearRemoteCache() {
    //            this.transport && Transport.resetCache();
    //        },
    //        filter: function (institutions) {
    //            $('.autopopulate-spinner').hide();
    //            return $.map(institutions, function (institution) {
    //                return {
    //                    value: institution.institutionName,
    //                    institutionCity: institution.institutionCity,
    //                    institutionState: institution.institutionState,
    //                    institutionMstrID: institution.institutionMstrID,
    //                    institutionCountryCode: institution.institutionCountryCode
    //                };
    //            });
    //        }
    //    }
    //});

    //// Initialize the Bloodhound suggestion engine
    //institutions.initialize();

    //// Instantiate the Typeahead UI

    //$("#affiliationName").typeahead({
    //    hint: false,
    //    highlight: true,
    //    minLength: 3
    //},
    //{
    //    displayKey: 'value',
    //    minLength: 3,
    //    limit: 10,
    //    dupChecker: true,
    //    source: institutions.ttAdapter(),
    //    templates: {
    //        suggestion: function (data) {
    //            return "<div>" + data.value + ", " + data.institutionCity + ", " + data.institutionState + ", " + data.institutionCountryCode + " </div>";
    //        },
    //        empty: [
    //                '<div style="background-color: #eeeeee;padding: 2px 5px;color: #000;">',
    //                    '<div style="display:inline-block">No Items Found</div>',
    //                '</div>'
    //        ].join('\n')
    //    }
    //}).bind('typeahead:selected', function (obj, datum, name) {

    //    $scope.selectedInstitute.InstitutionId = datum.institutionMstrID
    //    $scope.selectedInstitute.InstitutionName = datum.value;
    //    $scope.selectedInstitute.isAffiliationExists = true;
    //    $scope.selectedInstitute.userDefinedAffiliation = "";
    //    $scope.$apply();
    //    return false;
    //});

    $scope.selectedInstitute = {
        InstitutionId: 0,
        InstitutionName: '',
        isAffiliationExists: false,
        userDefinedAffiliation: ''
    };

    //$scope.setAffiliation = function () {

    //    if ($scope.selectedInstitute.InstitutionName.length > 0 || $scope.selectedInstitute.userDefinedAffiliation.length > 0) {

    //        $scope.profileData.InstitutionId = parseInt($scope.selectedInstitute.InstitutionId) > 0 ? $scope.selectedInstitute.InstitutionId : 0;
    //        $scope.profileData.InstitutionName = $scope.selectedInstitute.InstitutionName != '' ? $scope.selectedInstitute.InstitutionName : $scope.selectedInstitute.userDefinedAffiliation;

    //        $scope.profileForm.instituteName.$dirty = true;
    //        $scope.profileForm.instituteName.$touched = true;
    //        $scope.profileForm.instituteName.$valid = true;
    //        $('#institution-info').removeClass('hide');
    //        $('#affiliation').modal('hide');
    //    }
    //};

    $("#instituteName").on('focusout', function () {
        $('#instituteName').typeahead('close');

        $scope.profileData.InstitutionName = $('#instituteName').val();

        $scope.$apply();
        return false;
    });

    //$scope.deSelectInstitute = function () {
    //    $scope.profileData.InstitutionId = 1;
    //    $scope.profileData.InstitutionName = '';
    //    $scope.selectedInstitute.userDefinedAffiliation = '';
    //    $scope.selectedInstitute.isAffiliationExists = false;
    //    //$('#affiliationName').removeAttr('disabled');
    //    $('#institution-info').addClass('hide');

    //    $scope.profileForm.instituteName.$dirty = false;
    //    $scope.profileForm.instituteName.$untouched = true;
    //    $scope.profileForm.instituteName.$prestine = true;
    //}

    //$scope.clearAffiliationOnBackspace = function () {
    //    if ($('#affiliationName').val().length <= 0 && $scope.profileData.InstitutionName.length <= 0) {
    //        $scope.deSelectInstitute();
    //    }
    //}

    $scope.createUser = function () {
        if ($scope.ValidateUserDetails()) {
            progressBarService.showProgressBar();
            var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

            var userRegistrationInfo = {
                eSpectraFirstName: $scope.profileData.firstName,
                eSpectraLastName: $scope.profileData.lastName,
                eSpectraEmail: $scope.profileData.emailId,
                eSpectraPrimaryAffiliationID: parseInt($scope.profileData.InstitutionId) > 0 ? $scope.profileData.InstitutionId : 1,
                eSpectraPrimaryAffiliationName: $scope.profileData.InstitutionName,
                eSpectraIsAdmin: $scope.profileData.admin ? 1 : 0,
                eSpectraOrderStartDate: $scope.profileData.startDate,
                userSubscriptionType: $scope.profileData.subscription,
                isKratosData: $scope.profileData.isKratosData ? 1 : 0
            };
            loginService.createInternalUser(userRegistrationInfo).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.message = "User account has been created successfully.";
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    sendInternalRegistrationNotification(response.data);
                    $scope.profileDataModel();
                    $scope.profileForm.$setPristine();
                    $scope.profileForm.$setUntouched();
                }
                progressBarService.hideProgressBar();
            });
        }
    };

    $scope.ValidateUserDetails = function () {
        var returnVal = true;
        if (angular.element("#lastName").val() != '') {
            $("#lastName").removeClass("border-red");
            $("#lastName").siblings('span').find("span.error-msg").addClass('display-none')
            var regExp = /^[a-zA-Z](?!.*-.*-.*)(?!.*\s.*\s.*)[a-zA-Z- ]+$/;
            var isValid = regExp.test(angular.element("#lastName").val());
            if (isValid) {
                $("#lastName").removeClass("border-red");
                $("#lastName").siblings('span').find("span.error-msg").addClass('display-none')
            }
            else {
                if (returnVal) {
                    $("#lastName").focus();
                }
                $("#lastName").siblings('span').find("span.error-msg").removeClass('display-none')
                returnVal = false;
            }
        }
        else {
            //$("#lastName").addClass("border-red");
            if (returnVal) {
                $("#lastName").focus();
            }
            $("#lastName").siblings('span').find("span.error-msg").removeClass('display-none')
            returnVal = false;
        }

        if (!returnVal) {
            this.profileForm.lastName.$dirty = true;
        }

        return returnVal;
    }

    var sendInternalRegistrationNotification = function (userRegistrationInfo) {
        loginService.sendInternaldRegistrationNotification(userRegistrationInfo);
    };

    $scope.validatePassword = function (event) {
        commonService.validatePassword($scope, event);
    }

    $scope.CancelRegistration = function () {
        $scope.profileDataModel();
        $("form[name=profileForm]").trigger('reset');
        $('.border-red').removeClass('border-red');
        $('#strength').hide();
        $scope.selectedInstitute.userDefinedAffiliation = '';
        $scope.selectedInstitute.isAffiliationExists = false;

        $scope.profileForm.$setPristine();
        $scope.profileForm.$setUntouched();
    }

    $scope.setTextboxStyle = function () {
        $(".input-feild-textbox").on("focusin", function () {
            $(this).parent().siblings("label").addClass("active");
            $(this).siblings("label").addClass("active");
        }).focusout(function () {
            if (!$(this).val().trim()) {
                $(this).parent().siblings("label").removeClass("active");
                $(this).siblings("label").removeClass("active");
            }
        });
    };

    $scope.setTextboxStyle();

    $scope.reloadCaptcha = function () {
        $rootScope.$broadcast('reloadCaptcha', {});
    }

    $scope.createSuperadmin = function () {
        if ($scope.ValidateUserDetails()) {
            progressBarService.showProgressBar();
            var currentDate = new Date();
            //currentDate = currentDate.getDate() + "-" + (currentDate.getMonth() + 1) + "-" + currentDate.getFullYear();
            var userRegistrationInfo = {
                eSpectraFirstName: $scope.profileData.firstName,
                eSpectraLastName: $scope.profileData.lastName,
                eSpectraEmail: $scope.profileData.emailId,
                eSpectraOrderStartDate: currentDate,
                userSubscriptionType: "Unlimited",
                eSpectraIsSuperadmin: 1,
                isKratosData: 1
            };
            loginService.createInternalUser(userRegistrationInfo).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.message = "System administrator account has been created successfully.";
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    sendInternalRegistrationNotification(response.data);
                    $scope.profileDataModel();
                    $scope.profileForm.$setPristine();
                    $scope.profileForm.$setUntouched();
                }
                progressBarService.hideProgressBar();
            });
        }
    }

}]);
